import classnames from 'classnames'

export interface SurfaceCardProps extends React.HTMLAttributes<HTMLElement> {
  as?: 'article' | 'div' | 'li' | 'nav' | 'section'
  tone?: 'default' | 'muted'
}

const toneClassMap = {
  default: 'border-zinc-200 bg-white shadow-sm',
  muted: 'border-zinc-200 bg-zinc-50'
} satisfies Record<NonNullable<SurfaceCardProps['tone']>, string>

export default function SurfaceCard({
  as = 'section',
  className,
  tone = 'default',
  ...props
}: SurfaceCardProps) {
  const Component: React.ElementType = as

  return (
    <Component
      className={classnames(
        'rounded-3xl border p-6',
        toneClassMap[tone],
        className
      )}
      {...props}
    />
  )
}
